import React from 'react';
import PropTypes from 'prop-types';

function CustomStylesProvider({ direction, children }) {
  if (direction === 'rtl') {
    return <div dir="rtl">{children}</div>;
  }

  return children;
}

CustomStylesProvider.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string
};

export default CustomStylesProvider;
